import { Section } from "./data-types";

export const Projects: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Project A",
						content: () => [
							<p>
								Project A
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/1.jpg"
						},
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/2.jpg"
						},
					},
				},
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Project B",
						content: () => [
							<p>
								Project B
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/3.jpg"
						},
					},
				},
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Project C",
						content: () => [
							<p>
								Project C
							</p>
						]
					},
				}
			]
		}
	]
}
